import { render, staticRenderFns } from "./OneSimplify.vue?vue&type=template&id=7cf5fd13&scoped=true&"
import script from "./OneSimplify.vue?vue&type=script&lang=js&"
export * from "./OneSimplify.vue?vue&type=script&lang=js&"
import style0 from "./OneSimplify.vue?vue&type=style&index=0&id=7cf5fd13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf5fd13",
  null
  
)

export default component.exports